<template>
  <div>
    <Breadcrumbs title="Trabajadores"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'CoreWorkerProfileForm'}">
                  <i class="fa fa-user-plus"></i> Agregar trabajador
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                        ref="table"
                        :fields="datatableConfig.fields"
                        :opts="datatableConfig.options"
                        @editObject="editObject"
                        @disableObject="disableObject">
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import $ from 'jquery';
  window.jQuery = $;
  import VdtnetTable from 'vue-datatables-net';
  import 'datatables.net-bs4';
  import utils from '../../../utils';
  import axios from "axios";

  export default {
    components: {
      VdtnetTable
    },
    data(){
      return{
        datatableConfig : {
          options: {
            lengthMenu: [10, 25, 50],
            pageLength: 10,
            lengthChange: false,
            processing: true,
            serverSide: true,
            searchDelay: 500,
            fixedHeader: true,
            responsive: true,
            ajax: {
              url: axios.defaults.baseURL + '/api/core/v1.0/worker_profile/?format=datatables',
              type: "GET",
              headers: {
                Authorization: 'JWT ' + localStorage.getItem('token')
              },
              dataSrc: (json) => {
                return json['data'];
              }
            },
            language: {
              decimal: "",
              emptyTable: "No hay información",
              info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
              infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
              infoFiltered: "(Filtrado de _MAX_ total entradas)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ Entradas",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              zeroRecords: "Sin resultados encontrados",
              paginate: {
                first: "Primero",
                last: "Ultimo",
                next: "Siguiente",
                previous: "Anterior"
              }
            },
            "drawCallback": function () {
              // const num_row = $('.dataTables_length');
              $('div.vdtnet-container').removeClass('table-responsive');
              // num_row.find('select').removeClass('custom-select form-control');
              $('.dataTables_paginate').addClass('pull-right mt-2');
              $('.dataTables_info').addClass('mt-2');
            },
          },
          fields: {
            id: {
              data: 'id',
              visible: false,
              searchable: false,
            },
            superuser: {
              data: 'user.is_superuser',
              visible: false,
              searchable: false,
            },
            color: {
              name: 'color',
              label: 'Color',
              data: 'color',
              sortable: false,
              render: function (data, type, row) {
                return `<span class="badge" style="background-color: ${row['color']}"> <i class="fa"></i></span>`
              }
            },
            type: {
              name: 'type',
              label: 'Privilegio',
              data: 'type',
              sortable: true,
              render: function (data, type, row) {
                return utils.privilegeUser.find(options => row['type'] === options['id'])['name'];
              }
            },
            rut: {
              name: 'user__username',
              label: 'RUT',
              data: 'user.username',
              sortable: true,
            },
            first_name: {
              name: 'user__first_name',
              label: 'Nombres',
              data: 'user.first_name',
              sortable: true
            },
            last_name: {
              name: 'user__last_name',
              label: 'Apellidos',
              data: 'user.last_name',
              sortable: true
            },
            status: {
              name: 'user__is_active',
              label: 'Estado',
              data: 'user.is_active',
              render: function (data, type, row) {
                let status;
                if(row['user']['is_active']){
                  status = '<span class="badge badge-success">Habilitado</span>';
                }else{
                  status = '<span class="badge badge-danger">Deshabilitado</span>';
                }
                return status;
              }
            },
            actions: {
              label: 'Acciones',
              isLocal: true,
              render: function (data, type, row) {
                let status = '';
                if(!row['user']['is_superuser']){
                  if(row['user']['is_active']){
                    status = '<a href="javascript:void(0);" data-action="disableObject" title="Deshabilitar"><span class="badge badge-warning"><i class="fa fa-times"></i></span></a>'
                  }else{
                    status = '<a href="javascript:void(0);" data-action="disableObject" title="Habilitar"><span class="badge badge-success"><i class="fa fa-check"></i></span></a>'
                  }
                }
                return '' +
                    '<a href="javascript:void(0);" data-action="editObject" title="Modificar"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a> ' +
                    `${status}`;
              }
            }
          },
          quickSearch: '',
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalTable);
    },
    mounted() {
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    methods: {
      reloadTable() {
        // ELIMINAOS EL INTERVALO
        clearInterval(this.intervalTable);
        // RECARGAMOS
        this.$refs.table.reload();
        // GENERAMOS EL INTERVALO
        this.intervalTable = setInterval(() => {
          this.$refs.table.reload();
        }, utils.timeRefresh * 1000);
      },
      doSearch() {
        this.$refs.table.search(this.datatableConfig.quickSearch);
      },
      editObject(data){
        this.$router.push({'name': 'CoreWorkerProfileFormEdit', params: { objectId: data['id'] }});
      },
      async disableObject(row){
        let oldState = '';
        let newState = '';

        if(row['status']){
          oldState = 'Habilitado';
          newState = 'Deshabilitado';
        } else {
          oldState = 'Deshabilitado';
          newState = 'Habilitado';
        }

        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>cambiar el estado</b> del trabajador <b>${row['user']['first_name']} ${row['user']['last_name']}</b> de <b>${oldState}</b> a <b>${newState}</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/core/v1.0/worker_profile/' + row['id'] + '/';
            let data = {user: {is_active: !row['user']['is_active']}};
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if (response) {
              await this.$swal({
                title: 'Editado!',
                type: 'success',
                html: `Se ha editado el estado del trabajador de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
    },
  }
</script>

<style>
  .badge-warning {
    color: #ffffff !important;
    background-color: #ffc107;
  }
</style>